export default "__VITE_ASSET__5YASrA3$__"